module.exports = vue_common_3_0_2;